import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";

const CHECKLIST = [
  "Evaluate: a $1,500 evaluation of your OSHA and environmental records",
  "Set up: documentation setup included in the setup fee",
  "Maintain: Essentials, Standard or Premium, per site per month",
];

export default function ServiceLayer() {
  return (
    <section id="service-layer" className="bg-white py-[88px]">
      <div className="mx-auto max-w-[1160px] px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Chapter
            eyebrow="The service layer"
            title="A credentialed safety person on top of the software."
            lede="Software flags the work. A credentialed safety professional evaluates your site, sets up your records, and maintains them so you stay inspection-ready."
          />
          <Reveal delay={0.2}>
            <a
              href="/services"
              data-testid="service-layer-cta"
              className="inline-block rounded-lg border-2 border-navy text-navy font-bold px-7 py-3.5 hover:bg-navy hover:text-white transition-colors"
            >
              See services &amp; credentials
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div data-testid="service-layer-checklist" className="bg-navy rounded-[14px] p-8 md:p-10">
            <ul className="space-y-6">
              {CHECKLIST.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-safety flex items-center justify-center mt-0.5">
                    <Check size={16} className="text-white" />
                  </span>
                  <p className="text-white/90 text-base leading-relaxed">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
